import { render, staticRenderFns } from "./messageManagement.vue?vue&type=template&id=a8365e3e&"
import script from "./messageManagement.vue?vue&type=script&lang=js&"
export * from "./messageManagement.vue?vue&type=script&lang=js&"
import style0 from "./messageManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports